import { render, staticRenderFns } from "./LegalCard.vue?vue&type=template&id=2dd98844&scoped=true&"
import script from "./LegalCard.vue?vue&type=script&lang=js&"
export * from "./LegalCard.vue?vue&type=script&lang=js&"
import style0 from "./LegalCard.vue?vue&type=style&index=0&id=2dd98844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd98844",
  null
  
)

export default component.exports